import { useMutation, useMutationState, useQueryClient } from '@tanstack/react-query';

import { TUsers } from 'shared/services/types/users.types';
import { UsersService } from 'shared/services/users.service';

export const useActionUsers = () => {
  const queryClient = useQueryClient();

  const create = useMutation({
    mutationFn: (data: TUsers.CreateUser) => UsersService.createUser(data),
    mutationKey: ['create user'],
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['get users'] });
    }
  });

  const update = useMutation({
    mutationFn: (data: TUsers.UpdateUser) => UsersService.updateUser(data),
    mutationKey: ['update user'],
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['get users'] });
    }
  });

  const updateStates = useMutationState({
    filters: { mutationKey: ['update user'], status: 'pending' },
    select(mutation) {
      return mutation.state;
    }
  });

  return { create, update, updateStates };
};
